          <template>
    <v-card color="#FAFAFA" width="100%" flat>
            <v-layout row wrap class="justify-center mx-3">
                <v-flex lg8 md9 sm8 xs12 class="mx-2">
                  MiniView {{MiniView}}          
                <h2 style="text-align: center;">Explore our Services</h2><br><br><br>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/VoluntarySequestration'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
                        >
                        <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white">mdi-chess-king</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Voluntary Sequestration</h3>
                            <h4 class="font-weight-light pop--text mb-2">Explore the process of Voluntary Sequestration</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Unlock financial freedom with our High Court process. Swift, effective, and debt-free in 2 years. Expert guidance. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/DebtCounselling'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Parallax_Logo.jpeg"
                        >
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-knight</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1"><h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Debt Counselling</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Debt Counselling</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Navigate debt with the help of registered debt counsellors. Retain assets while renegotiating payments with creditors. Find tailored solutions for financial freedom. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/Rehabilitation'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Tribunes_Parallax_(Invert).jpeg"
                        >
                            
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-queen</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Rehabilitation</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Rehabilitation</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Restore your financial standing with early rehabilitation after sequestration. Obtain ITC clearance within 2-3 months and regain the ability to incur new debt. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                     <v-hover v-slot:default="{ hover }">
                        <v-card
                        :elevation="hover ? 16 : 0"
                        class="my-12"
                        color="primary"
                        dark
                        :to="'/Liquidation'"
                        >
                        <v-img
                            height="180px"
                            src="@/assets/Parallax_Logo.jpeg"
                        >
                         <v-card-text
                            class="voluntarysequestrationcontentgrad"
                            style="position: relative;"
                        >
                          <v-row style="margin-left:0px;">
                          <v-col cols="1">
                            <v-btn
                            absolute
                            outlined                            
                            color="pop"
                            fab
                            :large="!MiniView"
                            :small="MiniView"
                            left
                            >                            
                            <v-icon color="white" class="iconoutline">mdi-chess-rook</v-icon>
                            </v-btn>
                             </v-col>
                             <v-col class="mx-1">
                            <h3 :class="MiniView ? 'font-weight-light pop--text mb-2' : 'display-1 font-weight-light pop--text mb-2'"
                            :style="MiniView ? 'font-size: 2em;' : ''">Liquidation</h3>
                             <h4 class="font-weight-light pop--text mb-2">Explore the process of Rehabilitation</h4>
                            <div class="font-weight-light title mb-2" style="font-size: 1.2rem !important;line-height: 1.2rem!important;">
                            Efficiently dissolve your company with this process designed for insolvent companies. Prevent creditor claims and audits by taking timely action. Click to learn more!
                            </div>
                            </v-col>
                            </v-row>
                        </v-card-text>
                        </v-img>
                        </v-card>
                    </v-hover>
                </v-flex>
                </v-layout>            
            </v-card>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'


export default {
  name: 'Services',
metaInfo: {
    title: 'Services Offered - Tribunes SA',
    meta: [
      {
        name: 'description',
        content: 'Description of services offered by Tribunes SA.'
      },
      {
        name: 'keywords',
        content: 'Services, Debt Counselling, Liquidation, Tribunes SA'
      }
    ]
  },
    components: {
        },
    data() {
    return {      
      UserRecord: {},
      rules: {
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
    }
    },
    computed:{
      MiniView(){
        return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
      },
      userLoggedIn () {
      return this.$store.getters.user
    },
      
      
      
      

    },
    mounted () {
  window.scrollTo(0, 0)
},
    created(){
      this.FocusedViewToggle()
      this.IntranetViewToggle()
      this.CheckUser()

    },
    
    methods: {
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',false)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
      async CheckUser(){
            let vm = this
            await firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                  db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              console.log(vm.UserRecord)
                  })
                }
                else{
                }
            })
        },
          DateFormatter(date){
            if(date){
            let yearstring = date.split('-')[0]
              let monthstring = date.split('-')[1]
              let daystring = date.split('-')[2]
              let yearnumber = Number(yearstring)
              let monthnumber = Number(monthstring)
              let daynumber = Number(daystring)
              return new Date(yearnumber, monthnumber-1, daynumber)
              }
            else{
              return null
            }
          },

    }    
}
</script>

<style>
.parallaxbgcontentgrad {
  background-image: linear-gradient(to right, rgba(20,26,31,0.5), rgb(189,199,209, 1));
}
.transoutline{
    border: 1px solid black;
    background-color:pink
    /* color: rgba(255,255,255,0.05) */
}
.v-card--reveal {
    /* background-color: rgba(176, 7, 255, 0.5); */
  background-color: rgba(255, 193, 7, 0.75);
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index:10
}

.iconoutline{
  text-shadow: 0 0 3px #FF0000;
}
</style>

        
            
        